<template>
	<router-view id="app"></router-view>
</template>

<script>
	export default {
		name: 'app',
		mounted() {
			function checkIE() {
				return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
			}
			if (checkIE()) {
				window.addEventListener('hashchange', () => {
					var currentPath = window.location.hash.slice(1);
					// alert(currentPath);
					if (this.$route.path !== currentPath) {
						this.$router.push(currentPath)
					}
				}, false)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/App.vue